var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 3.33398H2.00065C1.63246 3.33398 1.33398 3.63246 1.33398 4.00065V12.6673C1.33398 13.0355 1.63246 13.334 2.00065 13.334H14.0007C14.3688 13.334 14.6673 13.0355 14.6673 12.6673V4.00065C14.6673 3.63246 14.3688 3.33398 14.0007 3.33398Z",
    stroke: "#D2D3E0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 2V4.66667M8.33464 7.66667H4.66797M11.3346 10.3333H4.66797M11.3346 2V4.66667",
    stroke: "#D2D3E0",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedules);
export default __webpack_public_path__ + "static/media/schedules.1759d3062d26515ae49a675b250674b5.svg";
export { ForwardRef as ReactComponent };